import { c as _c } from "react/compiler-runtime";
/**
 * Registers cross-page frontend tools inside an active CopilotProvider tree.
 * Kept outside CopilotContext.tsx so tool modules can import useCopilot without a cycle.
 */
import { type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import { useCopilotGlobalPageTools } from 'shared/copilot/tools/useCopilotGlobalPageTools';
const CopilotGlobalPageToolsWhenEnabled = () => {
  useCopilotGlobalPageTools();
  return null;
};
export const CopilotGlobalPageTools = () => {
  const $ = _c(1);
  const {
    isCopilotSidenavEnabled
  } = useCopilot();
  if (!isCopilotSidenavEnabled) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CopilotGlobalPageToolsWhenEnabled />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};